/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
// import axios from 'axios';

export default {
  namespaced: true,
  state: {
    currentWeek: undefined,
  },
  mutations: {
    setWeek(state, week) {
      state.currentWeek = week;
    },
  },
  getters: {},
  actions: {
    initWeek({
      commit,
    }, week) {
      commit('setWeek', week);
      // axios.get(`/api/timeshareweek/${weekId}`).then(r => commit('setWeek', r.data)).catch(console
      //  .error);
    },
  },
};
